var _style, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconServ04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000121249931704136795500000017349807593926557838_);fill:url(#SVGID_00000079458441007390870140000011159392836173770380_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000176744487339563477760000006472718050764511621_);fill:url(#SVGID_00000092432126604571312870000018298576566342623677_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000157283558361322450520000006578688523748188808_);fill:url(#SVGID_00000127011718304395186550000011952068414754191802_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000073697110339657124270000001220201615291572904_);fill:url(#SVGID_00000048458884741179323510000018380765116223584688_);}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000030466037412027620240000001761955824931863963_);fill:url(#SVGID_00000125600812767119360700000007149886366622874771_);}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000094589649140001415130000006629847456374700691_);fill:url(#SVGID_00000156573909569340898730000007008662412883713468_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000102541431185693244750000009618163420123515552_);fill:url(#SVGID_00000120549908712158931340000004408013898561282720_);}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000127002070631684731070000010206366270663830407_);fill:url(#SVGID_00000005228300018698389110000012587622400840685466_);}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000158029232590643279060000003050741055527993227_);fill:url(#SVGID_00000020374459570323035190000012775828905921305018_);}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000011723356248609307300000012270677375272866964_);fill:url(#SVGID_00000102526001519875459510000010172378948388955294_);}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000145053542832165740990000016140707468180160914_);fill:url(#SVGID_00000062903103664418095640000000827547925199785654_);}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000093879776200820279440000007344482664727799473_);fill:url(#SVGID_00000183225573771212064530000004179079591143979424_);}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000078041625210730181640000011476442158717764484_);fill:url(#SVGID_00000096781545532422307510000013007382814393615286_);}\n\t\n\t\t.st13{clip-path:url(#SVGID_00000171717067500006556780000000874801610001458584_);fill:url(#SVGID_00000178890099223945061700000009715197046424534445_);}\n\t\n\t\t.st14{clip-path:url(#SVGID_00000158722371164523337520000015106338192251679124_);fill:url(#SVGID_00000132075370263984869910000011317407639364342170_);}\n\t\n\t\t.st15{clip-path:url(#SVGID_00000058589709067930261360000001162310398198748288_);fill:url(#SVGID_00000158018069624163000840000013318134626593160371_);}\n\t\n\t\t.st16{clip-path:url(#SVGID_00000101801958546357724950000012154488090501869184_);fill:url(#SVGID_00000171001170489680958000000005844107339036089506_);}\n\t\n\t\t.st17{clip-path:url(#SVGID_00000016779782444987623140000005651605990159633032_);fill:url(#SVGID_00000072968100921434216610000001786186253016429226_);}\n\t\n\t\t.st18{clip-path:url(#SVGID_00000136376724850380094330000009304155115769690763_);fill:url(#SVGID_00000026139873970614503730000006694606119266732703_);}\n\t\n\t\t.st19{clip-path:url(#SVGID_00000137125440451993980310000006906462600772740529_);fill:url(#SVGID_00000049942635402802480240000016614968368477005472_);}\n\t\n\t\t.st20{clip-path:url(#SVGID_00000062896825693856718150000007067097077067137158_);fill:url(#SVGID_00000090293566432493886660000013615696353692397964_);}\n\t\n\t\t.st21{clip-path:url(#SVGID_00000155116346473584813770000003310789763818724758_);fill:url(#SVGID_00000063614534910045009830000002519529707082614195_);}\n\t\n\t\t.st22{clip-path:url(#SVGID_00000115473652804202442450000007564648055696957570_);fill:url(#SVGID_00000075863021686939528770000003592769249568458119_);}\n\t\n\t\t.st23{clip-path:url(#SVGID_00000132799823948305609860000010763373532871191950_);fill:url(#SVGID_00000031204913430638404380000018414942233102565033_);}\n\t\n\t\t.st24{clip-path:url(#SVGID_00000075126012691885677050000015050677756225067145_);fill:url(#SVGID_00000018218668432379208370000010802458126668578993_);}\n\t\n\t\t.st25{clip-path:url(#SVGID_00000035491132170870186000000007921333026143863470_);fill:url(#SVGID_00000004522868985117422990000006732429770115492535_);}\n\t\n\t\t.st26{clip-path:url(#SVGID_00000001665230281978985220000015835972442651927480_);fill:url(#SVGID_00000036959834145301102580000000278292502370108094_);}\n\t\n\t\t.st27{clip-path:url(#SVGID_00000180366318270997781520000000099677064769152406_);fill:url(#SVGID_00000051364062169773778640000014444698330256307332_);}\n\t\n\t\t.st28{clip-path:url(#SVGID_00000015351215245547098830000011382602389422951613_);fill:url(#SVGID_00000128449689888257273160000013286245829132720816_);}\n\t\n\t\t.st29{clip-path:url(#SVGID_00000011737706966438006350000010594926009954160059_);fill:url(#SVGID_00000112594813063605864940000017429080227434309279_);}\n\t\n\t\t.st30{clip-path:url(#SVGID_00000008118401839544167630000007385917478474596287_);fill:url(#SVGID_00000168803824594891428220000014883138960876563106_);}\n\t\n\t\t.st31{clip-path:url(#SVGID_00000060017463912244084650000007477817171140023172_);fill:url(#SVGID_00000000195795011170289190000007184627895789237903_);}\n\t\n\t\t.st32{clip-path:url(#SVGID_00000088814306935382109980000014021620100579628705_);fill:url(#SVGID_00000127730145227545712720000015753769044723772814_);}\n\t\n\t\t.st33{clip-path:url(#SVGID_00000065040847490746289000000003062803411905641396_);fill:url(#SVGID_00000088132303164900362150000011725316675797285252_);}\n\t\n\t\t.st34{clip-path:url(#SVGID_00000005954243320964891030000000945684373370562433_);fill:url(#SVGID_00000023268498383310683420000001623035328422765489_);}\n\t\n\t\t.st35{clip-path:url(#SVGID_00000056410404979227020660000015849187587287822988_);fill:url(#SVGID_00000173869611631975488920000004976266828970578858_);}\n\t\n\t\t.st36{clip-path:url(#SVGID_00000075872806751709715920000003704150895711487915_);fill:url(#SVGID_00000075141819509891191990000015676635945320964747_);}\n\t\n\t\t.st37{clip-path:url(#SVGID_00000137089865018060396260000003712794859886463396_);fill:url(#SVGID_00000031917815737498051430000009808182653975725479_);}\n\t\n\t\t.st38{clip-path:url(#SVGID_00000096034323701286043330000004457239524486714027_);fill:url(#SVGID_00000013159372344045720260000011021869346677962173_);}\n\t\n\t\t.st39{clip-path:url(#SVGID_00000122702739449511644980000016519077199065183649_);fill:url(#SVGID_00000178194061026722788440000008480034050408818320_);}\n\t\n\t\t.st40{clip-path:url(#SVGID_00000101821907668462943410000009222085662902618554_);fill:url(#SVGID_00000067224143005556407010000015553617530973876641_);}\n\t\n\t\t.st41{clip-path:url(#SVGID_00000144314696690214404570000013181376262130546362_);fill:url(#SVGID_00000155147272952573935620000015891607699085780132_);}\n\t\n\t\t.st42{clip-path:url(#SVGID_00000181776585632281583580000009076688034129900214_);fill:url(#SVGID_00000023270849000089899210000016953750725374965888_);}\n\t\n\t\t.st43{clip-path:url(#SVGID_00000183948161523802946700000013089416037099700629_);fill:url(#SVGID_00000041269366725465187520000016854098848083869868_);}\n\t\n\t\t.st44{clip-path:url(#SVGID_00000145056336009972939490000004759750415477053866_);fill:url(#SVGID_00000061432476429904494710000010953093986474225084_);}\n\t\n\t\t.st45{clip-path:url(#SVGID_00000139261372066556339500000004914553133603091355_);fill:url(#SVGID_00000132059567649444758360000003570902830904038297_);}\n\t\n\t\t.st46{clip-path:url(#SVGID_00000016776377336021219320000018058371087079260547_);fill:url(#SVGID_00000159444450003101112830000016598291680926332059_);}\n\t\n\t\t.st47{clip-path:url(#SVGID_00000042700040775271588300000011633772366914289318_);fill:url(#SVGID_00000036245674925848105850000003501999396855163778_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000047036144545504001050000013394033237964643222_",
    d: "M12.1,31.6c0-0.9,0.7-1.6,1.6-1.6 c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6C12.8,33.2,12.1,32.4,12.1,31.6 M9.5,31.6c0,2.3,1.8,4.1,4.1,4.1 c2.3,0,4.1-1.8,4.1-4.1s-1.8-4.1-4.1-4.1C11.4,27.4,9.5,29.3,9.5,31.6"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041289894038583273880000015857291007214532760_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.6675,
    y1: 35.6821,
    x2: 13.6675,
    y2: 15.161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047036144545504001050000013394033237964643222_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000041289894038583273880000015857291007214532760_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008123751628638548120000015223943194894684066_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047036144545504001050000013394033237964643222_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100381526088498510210000014555039803366748062_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.6675,
    y1: 35.6821,
    x2: 13.6675,
    y2: 15.161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 27.4,
    style: {
      clipPath: "url(#SVGID_00000008123751628638548120000015223943194894684066_)",
      fill: "url(#SVGID_00000100381526088498510210000014555039803366748062_)"
    },
    width: 8.3,
    height: 8.3
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000124145544774100988320000007942996027778199697_",
    d: "M38.1,31.6c0-0.9,0.7-1.6,1.6-1.6 c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6C38.8,33.2,38.1,32.4,38.1,31.6 M35.5,31.6c0,2.3,1.8,4.1,4.1,4.1 c2.3,0,4.1-1.8,4.1-4.1c0-2.3-1.8-4.1-4.1-4.1C37.4,27.5,35.5,29.3,35.5,31.6"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010303703705395300220000000100703025665654185_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.6508,
    y1: 35.6821,
    x2: 39.6508,
    y2: 15.161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124145544774100988320000007942996027778199697_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000010303703705395300220000000100703025665654185_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146481041072198602940000009294252252842489279_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124145544774100988320000007942996027778199697_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161590780973036102230000009861833939815774346_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.6508,
    y1: 35.6821,
    x2: 39.6508,
    y2: 15.161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 27.5,
    style: {
      clipPath: "url(#SVGID_00000146481041072198602940000009294252252842489279_)",
      fill: "url(#SVGID_00000161590780973036102230000009861833939815774346_)"
    },
    width: 8.3,
    height: 8.3
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000129921839564380145010000007291837583896130209_",
    d: "M28.6,21.1v-4.6c0-0.2,0.2-0.4,0.4-0.4h2.3 c0.1,0,0.3,0.1,0.3,0.2l4.8,4.6c0.2,0.2,0.1,0.5-0.2,0.5h-6.9h-0.4C28.7,21.4,28.6,21.3,28.6,21.1 M22.2,16.5 c0-0.2,0.2-0.5,0.5-0.5h3.6c0.3,0,0.5,0.2,0.5,0.5v4.9h-4.5V16.5z M28.5,14.3h-1.7h-6c-0.2,0-0.4,0.2-0.4,0.4V22H2.5v7.3 c0,0.8,0.6,1.4,1.4,1.5h4c0.2,0,0.3-0.2,0.3-0.3C8.7,27.8,11,26,13.7,26c2.7,0,5,1.8,5.4,4.4c0,0.2,0.2,0.3,0.3,0.3H20h6.8H27h7 c0.2,0,0.3-0.2,0.3-0.3c0.4-2.6,2.7-4.5,5.4-4.5c2.7,0,5,2,5.4,4.5c0,0.2,0.1,0.3,0.3,0.3h0.5c0.9,0,1.6-0.7,1.6-1.6V28 c0-0.2-0.2-0.4-0.4-0.4h-0.9v-3.8c0-1.3-1-2.5-2.3-2.5h-4.3c-0.1,0-0.2,0-0.3-0.1l-6.7-6.5c-0.3-0.3-0.7-0.6-1.1-0.6H28.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104684588881474243310000013329264567385878185_",
    gradientUnits: "userSpaceOnUse",
    x1: 25,
    y1: 35.6821,
    x2: 25,
    y2: 15.161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129921839564380145010000007291837583896130209_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000104684588881474243310000013329264567385878185_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169557090607215255090000016264596261054340012_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129921839564380145010000007291837583896130209_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047052406275803579440000010241804858900767913_",
    gradientUnits: "userSpaceOnUse",
    x1: 25,
    y1: 35.6821,
    x2: 25,
    y2: 15.161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 14.3,
    style: {
      clipPath: "url(#SVGID_00000169557090607215255090000016264596261054340012_)",
      fill: "url(#SVGID_00000047052406275803579440000010241804858900767913_)"
    },
    width: 45,
    height: 16.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServ04);
export default __webpack_public_path__ + "static/media/IconServ-04.c10ffc082f3727c92baacac1ee91fd4e.svg";
export { ForwardRef as ReactComponent };